// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8zkoA","questions":"styles_questions__3YlgQ","footer":"styles_footer___ltCR"};